"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var surface_1 = require("../surface");
var panelHeader_1 = require("../panelHeader");
exports.default = (function (_a) {
    var children = _a.children, theme = _a.theme, style = _a.style, className = _a.className, title = _a.title, actionIconName = _a.actionIconName, onAction = _a.onAction, _b = _a.surfaceLevel, surfaceLevel = _b === void 0 ? 1 : _b;
    return (React.createElement(surface_1.Surface, { className: classnames_1.default(theme.surface, className), style: style, level: surfaceLevel },
        React.createElement(panelHeader_1.PanelHeader, { className: theme.header, title: title, onAction: onAction, actionIconName: actionIconName }),
        React.createElement("div", { className: theme.body }, children)));
});
